import React from "react";
import FlowsPerProtocolReport from "./Report";
import View from "common/View";
import Help from "./Help";

const FlowsPerProtocol = () => (
  <View title="Active Flows Over Time" Help={Help}>
    <FlowsPerProtocolReport />
  </View>
);

export default FlowsPerProtocol;
